import React, { Component, createContext, useContext, useState } from 'react'
import { Storage } from './'

export type StoreState = {
  username: string
  score: number
  errors: number
  timeMs: number
  isWinter: boolean
  isFirstRun: boolean
  games: {
    [gameId: string]: {
      score: number
      errors: number
      timeMs: number
    }
  }
}
export type StoreContextType = {
  state: Readonly<StoreState>
  setState: (nextState: StoreState) => StoreState | any
  patchState: (nextStatePart: Partial<StoreState>) => StoreState | any
}
export const StoreContext: React.Context<StoreContextType> = createContext<StoreContextType>({
  state: {
    username: '',
    score: 0,
    errors: 0,
    timeMs: 0,
    isWinter: false,
    isFirstRun: true,
    games: {},
  },
  setState: () => {},
  patchState: () => {},
})

type Props = {
  children: Component | Element | any
}

export const StoreContextProvider: React.FC<Props> = ({ children }) => {
  const ctx = createStoreContext()
  return <StoreContext.Provider value={{ ...ctx }}>{children}</StoreContext.Provider>
}

export const useStore = (): StoreContextType => {
  return useContext(StoreContext)
}

const createStoreContext = (): StoreContextType => {
  const initState = Storage.get() || {
    username: '',
    score: 0,
    errors: 0,
    timeMs: 0,
    isWinter: false,
    isFirstRun: true,
    games: {},
  }
  if (isNaN(initState.timeMs)) {
    initState.timeMs = 0
  }
  const [state, setState] = useState<StoreState>(initState)
  const replaceState = (nextState: StoreState) => {
    Storage.set(nextState)
    setState(nextState)
  }
  const patchState = (nextStatePart: Partial<StoreState>) => {
    // console.warn('patchState', {...nextStatePart}, {...state}) // TODO: remove
    const nextState = { ...state, ...nextStatePart }
    Storage.set(nextState)
    setState(nextState)
  }
  return {
    state,
    setState: replaceState,
    patchState,
  }
}
